export const SET_VALUE = 'VALUE/SET_VALUE';
export const GET_VALUE = 'VALUE/GET_VALUE';
